/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import React from 'react'
import PropTypes from 'prop-types'
import WordCloud from 'react-wordcloud'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/scale.css'

// 定義文字雲的選項 (可依照需求進行自訂)
const options = {
  rotations: 2,
  rotationAngles: [-90, 0],
  fontSizes: [20, 60],
}

function MyWordCloud({ setting }) {
  const { words } = setting
  return (
    <div style={{ height: 500, width: '100%' }}>
      <WordCloud options={options} words={words} />
    </div>
  )
}

MyWordCloud.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default MyWordCloud
